import { request } from '@/utils/request'

export async function getList(params) {
    console.log("调用api")
  return request(`/platform/lowAssetType/selectTypes?organizationId=${params.organizationId}`, 'post', params)
}
export async function lowAssetUseUpdate(params){ //备货完成 按钮
  return request(`/platform/lowAssetUse/update?ids=${params}`,'post')
}

export async function lowAssetUseCancelByAgent(params){//驳回 按钮
  return request(`/platform/lowAssetUse/cancelByAgent?id=${params}`,'post')
}
export async function lowAssetUpdateByNote(data){ //签收
  console.log(data.ids)
  return request(`/platform/lowAssetUse/updateByNote`,'post',data)
}


export async function insert(params){
  return request('/platform/lowAssetUse/insert','post',params)
}
export async function findList(params){

  return request(`/platform/lowAssetUse/selectPage?pageSize=${params.pageSize}&pageNum=${params.pageNum}&orderBy=createTime desc`,'post',params)
}

export async function repealList(params){

  return request(`/platform/lowAssetUse/cancelByUser?id=${params}`,'post')
}
export async function findClass(params){

  return request(`/platform/shiWai/selectClassroom?number=${params}`,'post')
}

export async function queryOtherOrganizations(param){//查看其他绑定的机构关系
  return request(`/platform/shiWai/queryOtherOrganization?number=${param}`,'post')

}

export async function changeLogins(params){//切换登录
  return request(`/platform/shiWai/changeLogin`,'post',params)

}


export async function getDingUser(code,corpId){//获取用户信息
  return request(`/platform/ding/getDingUser?code=${code}&corpId=${corpId}`,'get')
}

export async function getUserNumbyUserId(userId){//根据钉钉id返回usernum 
  return request(`/platform/ding/getNumber?userId=${userId}`,'get')

}

export async function bindDingandLiu(data){//绑定钉钉跟lk
  return request(`/platform/ding/bind`,'post',data)
}


export async function loginOut(userId){//解绑钉钉跟lk
  return request(`/platform/ding/deleteBind?userId=${userId}`,'post')
}


// WEBPACK FOOTER //
// ./src/api/index.js